import createProbingSessionTab from './create-probing-session-tab'

export default createProbingSessionTab({ isTemplate: true })
